import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";

const Dislike = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [comment, setComments] = useState([]);
  const [slugError, setSlugError] = useState("");
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [originalSlug, setOriginalSlug] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const axiosAPI = useAxios();

  const formatDateTime = (dateTime) => {
    if (!dateTime) return "-";
    const date = new Date(dateTime);
    if (Number.isNaN(date.getTime())) return "-";
    return date.toLocaleString();
  };

  const [formData, setFormData] = useState({
    product_name: "",
    description: "",
    media_type: "",
    thumbnail_url: "",
    product_url: "",
    slug: "",
    category_id: "",
    sub_category_id: "",
  });

  function removeFormData() {
    setFormData({
      product_name: "",
      description: "",
      media_type: "",
      thumbnail_url: "",
      product_url: "",
      slug: "",
      category_id: "",
      sub_category_id: "",
    });
    setSlugError("");
  }

  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  async function fetchComment() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(
        `/api/like/dislike/get-like-and-dislike?page=${page}`
      );
      setComments(response?.data?.comments);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  useEffect(()=>{
    fetchComment()
  },[page])

  const openEditModal = (commentId, currentStatus) => {
    setIsEditMode(true);
    // setCurrentUserId(commentId);
    // changeCommentStatus(commentId, currentStatus);
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/like/dislike/delete/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchComment();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  useEffect(() => {
    fetchComment();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Comment" : "Add Comment"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
            </div>
          </div>
        </div>

        {/* Product Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  All Likes and Dislikes ({comment?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Proudct Name</th>
                        <th>Category</th>
                        <th>Sub Caetgory</th>
                        <th>Like or Dislike</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : comment?.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No Like and Dislike found.
                          </td>
                        </tr>
                      ) : (
                        comment &&
                        comment?.map((comment) => (
                          <tr key={comment.id}>
                            <td>{comment?.full_name}</td>
                            <td>{comment?.product_name}</td>
                            <td>{comment?.category_name}</td>
                            <td>{comment?.subcategory_name}</td>
                            <td>{comment?.user_like_dislike}</td>
                            <td>{formatDateTime(comment?.created_at)}</td>
                            {/* <td>{comment?.status}</td> */}

                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                onClick={() =>
                                  openEditModal(comment.id, comment.status)
                                }
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(comment.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dislike;
